import vars from '@/assets/styles/vars'

export default function Picture({ desktop, tablet, mobile }) {
  const desktopImages = desktop || {}
  const {
    x1: desktop_x1,
    x2: desktop_x2,
    webp_x1: desktop_webp_x1,
    webp_x2: desktop_webp_x2,
  } = desktopImages

  const tabletImages = tablet || {}
  const {
    x1: tablet_x1,
    x2: tablet_x2,
    webp_x1: tablet_webp_x1,
    webp_x2: tablet_webp_x2,
  } = tabletImages

  const mobileImages = mobile || {}
  const {
    x1: mobile_x1,
    x2: mobile_x2,
    webp_x1: mobile_webp_x1,
    webp_x2: mobile_webp_x2,
  } = mobileImages

  return desktop_x1 && desktop_x1.endsWith('.svg') ? (
    <img src={desktop_x1} alt="" />
  ) : (
    <picture>
      <source
        type="image/webp"
        media={`(min-width: ${vars.breakpoints.tablet + 1}px)`}
        srcSet={`${desktop_webp_x1}, ${desktop_webp_x2} 2x`}
      />
      <source
        media={`(min-width: ${vars.breakpoints.tablet + 1}px)`}
        srcSet={`${desktop_x1}, ${desktop_x2} 2x`}
      />

      <source
        type="image/webp"
        media={`(min-width: ${vars.breakpoints.mobile + 1}px)`}
        srcSet={`${tablet_webp_x1}, ${tablet_webp_x2} 2x`}
      />
      <source
        media={`(min-width: ${vars.breakpoints.mobile + 1}px)`}
        srcSet={`${tablet_x1}, ${tablet_x2} 2x`}
      />

      <source
        type="image/webp"
        media={`(max-width: ${vars.breakpoints.mobile}px)`}
        srcSet={`${mobile_webp_x1}, ${mobile_webp_x2} 2x`}
      />
      <source
        type="image/png"
        media={`(max-width: ${vars.breakpoints.mobile}px)`}
        srcSet={`${mobile_x1}, ${mobile_x2} 2x`}
      />

      <img src={desktop_x1} srcSet={`${desktop_x2} 2x`} alt="" />
    </picture>
  )
}
